import { MessageCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const TONINI_URL =
  "https://t.me/+RY4N9mgvs_xjNmI0";

export default function ToniniFloatingWidget() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <>
      <a
        href={TONINI_URL}
        data-testid="tonini-floating-widget"
        title="NAŠA Adria Chat"
        aria-label="NAŠA Adria Chat"
        className="tonini-fab group fixed bottom-16 right-5 z-[60] flex items-center justify-center"
      >
        {/* Pulse rings */}
        <span aria-hidden="true" className="tonini-fab-ring tonini-fab-ring-1" />
        <span aria-hidden="true" className="tonini-fab-ring tonini-fab-ring-2" />

        {/* Main button */}
        <span className="tonini-fab-core relative w-[60px] h-[60px] rounded-full flex items-center justify-center text-black">
          <MessageCircle className="w-6 h-6" strokeWidth={2.5} />
        </span>

        {/* Hover label (desktop only) */}
        <span className="tonini-fab-label hidden md:flex items-center gap-1.5 ml-3 px-3 py-2 rounded-sm bg-black border border-[#ff7a18]/50 text-[11px] uppercase tracking-[0.25em] text-[#ff7a18] whitespace-nowrap">
          <span className="font-bold">NAŠA</span>
          <span className="text-zinc-400 normal-case tracking-normal">Adria Chat</span>
        </span>

      </a>

      <style>{`
        .tonini-fab {
          text-decoration: none;
          cursor: pointer;
          /* Account for iOS safe area at the bottom of the screen */
          padding-bottom: env(safe-area-inset-bottom, 0px);
        }
        .tonini-fab-core {
          will-change: transform;
          transform: translateZ(0);
          background: linear-gradient(135deg, #ff7a18 0%, #ffb24a 60%, #ff7a18 100%);
          box-shadow:
            0 0 0 1px rgba(255,122,24,0.6),
            0 8px 24px rgba(255,122,24,0.45),
            inset 0 -3px 8px rgba(0,0,0,0.25);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .tonini-fab:hover .tonini-fab-core {
          transform: scale(1.08) rotate(8deg);
          box-shadow:
            0 0 0 1px rgba(255,122,24,1),
            0 12px 36px rgba(255,122,24,0.7),
            0 0 60px rgba(34,255,119,0.25);
        }
        .tonini-fab:active .tonini-fab-core { transform: scale(0.96); }
        .tonini-fab-ring {
          will-change: transform, opacity;
          position: absolute;
          inset: 0;
          margin: auto;
          width: 60px;
          height: 60px;
          border-radius: 9999px;
          border: 2px solid rgba(255,122,24,0.7);
          pointer-events: none;
        }
        .tonini-fab-ring-1 { animation: none; }
        .tonini-fab-ring-2 { animation: none; }
        @keyframes tonini-ring {
          0%   { transform: scale(1);   opacity: 0.7; }
          80%  { transform: scale(1.9); opacity: 0;   }
          100% { transform: scale(1.9); opacity: 0;   }
        }
        .tonini-fab-label {
          opacity: 0;
          transform: translateX(-10px);
          transition: opacity 0.2s ease, transform 0.2s ease;
          pointer-events: none;
          position: absolute;
          right: 70px;
          top: 50%;
          margin-top: -16px;
        }
        .tonini-fab:hover .tonini-fab-label {
          opacity: 1;
          transform: translateX(0);
        }
        @media (max-width: 640px) {
          .tonini-fab { bottom: 16px; right: 16px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .tonini-fab-ring { animation: none; opacity: 0; }
          .tonini-fab-core { transition: none; }
        }
      `}</style>
    </>
  );
}
